// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3G_hG","col":"styles_col__32CO5"};